import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { fluidType } from 'Shared/common/FluidType';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { NoticiaText } from 'Shared/frontend/fonts/NoticiaText';
import { INav } from 'Common/config/INav';
import {PeopleCircle} from 'Shared/frontend/icons/PeopleCircle'; 
import {PeopleCircle as BackendPeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';
import { backgroundColour } from 'Shared/backend/Theme';




export class IndieIslandSettings extends BaseSettings
{
	palette()
	{
		return{
			background: '#000000',
			text: '#ffffff',
			feature: '#7AC24C', //flurogreen
			feature2: '#333d8a', //FoxyPurple
			inverseText: '#000000',

		
			dimBackground: '#232323',

			food: '', 
			drinks: '',
		
		};
	}

	fontIncludes()
	{
		return [
			NunitoSans,
			NoticiaText,
		];
	}

	fontsText()
	{
		return({
			fontFamily: '"Nunito Sans", serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,18),		
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Noticia Text", serif',
			letterSpacing: 2,
			color: this.palette().feature,	
			lineHeight: 1.1,
			fontWeight: '700',
		})
	}

	fonts()
	{
		return {
			text: '"Nunito Sans", serif',
			heading:  '"Noticia Text", serif',
			subNav:  '"Noticia Text", serif',
			buttons:  '"Noticia Text", serif',
			desktopNav:  '"Noticia Text", serif',
			mobileNav:  '"Noticia Text", serif',
		};
	}

	
	//used on Teaser,Title,Tagline so they layout evenly and collapse when needed
	textMargins()
	{
		return({
			margin: '.5em 0',
		})
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,70),
		
			},
			title: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,40,70),
			},
			plain: {
				...this.fontsText(),
			},

			teaser: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),
			},
			tagline: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,20),	
				
			},

			subtitle: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,50),
				
			},
		});
	}


	//TODO BEN these might also work as a 'style' so users can select the button type they want
	button()
	{
		return({
			hollow: {
				button: {
					color: this.palette().feature,
					border: 'solid 3px',
					borderColor: this.palette().feature,
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
					textTransform: 'uppercase',
					backgroundColor: this.palette().dimBackground
				},
				
			},
			filled: {
				button: {
					backgroundColor: this.palette().feature,
					color: this.palette().text,
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
					borderRadius: '0.4em',
				},
			}
		})
	}
	

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().dimBackground,
					...this.fontsHeading(),
					lineHeight: 1.1,
					color: this.palette().feature,
					
				},
				dateBar: {
					backgroundColor: this.palette().dimBackground,
					...this.fontsHeading(),
					fontSize: '16px',
					color: this.palette().feature,
					
				},
			
			},
			themes:{
				overlapping:{
					tagline: {
						...this.fontsText(),
						fontStyle: 'normal',	
					},
				},
			},
		});
	}

	page()
	{
		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

			heading: {
				color: this.palette().feature,
			},
			
			section: {},

			...this.button().filled,

			widgets: {
				scrollStyle:{
					scrollbarColor: '#7AC24C #000000 !important', //#sliderColor #outerColor
				},
				overlay: {

					'.text-teaser':{
						fontWeight: '700',
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,32),
						textShadow: '0 0 5px black',
						color: this.palette().feature,		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,64),
						textShadow: '0 0 5px black',
						color: this.palette().feature,
					},

					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,36),
						fontWeight: '300',
						textShadow: '0 0 5px black',
						color: this.palette().feature,
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,50),
						textShadow: '0 0 5px black',
						color: this.palette().text,
					},
					'.text-plain': {
						//fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,64),
						textShadow: '0 0 5px black',
						color: this.palette().text,
					},
					button: {
						color: this.palette().text,
						backgroundColor: this.palette().feature,
					}
				},
				subNav: {
					...this.button().hollow,
				},
			},

		});
	}


	//navigation settings
	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				type: 'standard',
				
				settings: {
				
					outer: {background: palette.background,},
					
					logo:{
						padding: '10px 0px',
					},	
					button: {
						...this.fontsHeading(),
						color: palette.feature,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,14,20),
				
					},
				
					active: {
						color: palette.text,
					},

					hover: {
						color: palette.text,
					},

					
				}
			},

			mobile:{		
				overlay:{background: palette.background},
		
				button:{
					color: palette.text,
					background: palette.background,

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.text} !important`
					},

					':hover': {
			//TODO cf remove from BaseTheme?						
		//						color: this.palette().inverseText,
						backgroundColor: this.palette().feature2
					}
				},
				active: {
					color: palette.feature,
					svg:{
						fill: `${palette.feature} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.background,

					},
					button: {
						color: this.palette().text,
						':hover': {
							color: this.palette().feature,
							backgroundColor: this.palette().feature2,
						}
					}
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		//Defaults to 'General' unless uncommented and altered
		/*base.specials = {
			general: 'General',
			beers: 'Beers'
		};
		*/

		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					...this.button().hollow
				},

				heading: {
					...this.fontsHeading(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
				},
				artist: {
					heading: {
						color: palette.feature,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					...this.button().hollow,
				},
				section: {
					marginBottom: '3em'
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsText(),
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}


	pages()
	{
		return [
			
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					title: 'Book'
				}
			},
			
			
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				//Todo Ben book buttons are not linking to page
			//	{label:'Book',		link:'frontend/Book'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'},

			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
				//	{label:'Book',		link:'frontend/Book', 	icon:PeopleCircle},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:BackendPeopleCircle},
		];
	}

}

